import React from "react";
import "./CalendarTile.css";

const getColorForType = (type) => {
  switch (type) {
    case 53:
      return "#339FFF";
    case "Bac Jaune":
      return "#ffff00";
    case 55:
      return "#ffff00";
    case 15:
      return "#22834b";
    case 11:
      return "#4f4f4f";
    case 3:
      return "#8b4513";
    case 32:
      return "#8ab13d";
    case 52:
      return "#adc9c5";
    case 54:
      return "#d873ed";
    case 58:
      return "#0000DD";
    case 73:
      return "#800000";
    default:
      return "#3E3EE3";
  }
};



const CalendarTile = ({ date, collectionDates, monthIndex , selectedType }) => {
  if (date.getMonth() !== monthIndex) {
    return null;
  }

  // console.log(selectedType)


  const filteredDates = collectionDates.filter((collectionDate) => {
    const collectionDateObj = new Date(collectionDate.dates);
    return (
      collectionDateObj.getDate() === date.getDate() &&
      collectionDateObj.getMonth() === date.getMonth() &&
      collectionDateObj.getFullYear() === date.getFullYear() &&
      (selectedType === "toustypes" || collectionDate.type == selectedType)

    );
  });

  // console.log(
  //   "Filtered dates for",
  //   date.toISOString().substring(0, 10),
  //   ":",
  //   filteredDates
  // );

  return (
    <div className="tile-container">
      {filteredDates.map((filteredDate, index) => (
        <div
          key={index}
          className={`tile-point ${
            filteredDate.type ? "enabled" : "disabled"
          }`}
          style={{
            backgroundColor: getColorForType(filteredDate.type),
          }}
        ></div>
      ))}
    </div>
  );
};






export default CalendarTile;

